import React, { useCallback, useEffect, useMemo, useState } from "react";
import { isAfter, isBefore } from "date-fns";

import useHomeModals from "./hooks/useHomeModals";
import { TYPE_PROMOTION } from "./enums";
import { config } from "./config";
import { getNPSStatus } from "services/npsServices";
import { orderShowModal } from "./hooks/orderShowModal";

import {
  getAvailable,
  updateNotification,
} from "./services/modalPesquisaSatisfacaoServices";

import {
  Button,
  ButtonClose,
  ButtonNPS,
  ButtonNPSContainer,
  CloseContainer,
  Container,
  Content,
  ImgBanner,
  TextSubTitle,
  TextTitle,
  TextWrapper,
} from "./styles";

const BannerPromotions: React.FC = () => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [dynamicUrl, setDynamicUrl] = useState<string>("");
  const [idNotification, setIdNotification] = useState<string | null>(null);
  const { handleNextModal, showActiveModal } = useHomeModals();

  const [atualPromotion] = useMemo(() => {
    const [modalType] = orderShowModal.filter(
      (order) => order.id === showActiveModal
    );

    return config.filter((conf) => conf.type === modalType.modal);
  }, [showActiveModal]);

  const getInitialParams = useCallback(async () => {
    const initialDate = atualPromotion?.start
      ? isBefore(atualPromotion.start, new Date())
      : true;

    const endDate = atualPromotion?.end
      ? isAfter(atualPromotion.end, new Date())
      : true;

    const isClosed =
      localStorage.getItem(
        `@UltragazEmpresarial:${atualPromotion.localStorageKey}`
      ) === "yes";

    const hasMFAToken = localStorage.getItem("@UltragazEmpresarial:X-Mfa-Hash");

    let isNeedShowModal = initialDate && endDate && !isClosed;

    if (atualPromotion.type === TYPE_PROMOTION.NPS && isNeedShowModal) {
      isNeedShowModal = (await getNPSStatus(setDynamicUrl)) && !isClosed;
    }

    if (atualPromotion.type === TYPE_PROMOTION.AVISO_MFA && isNeedShowModal) {
      isNeedShowModal = !hasMFAToken;
    }

    if (
      atualPromotion.type === TYPE_PROMOTION.PESQUISA_USABILIDADE &&
      isNeedShowModal
    ) {
      isNeedShowModal = await getAvailable(setIdNotification);
    }

    setShowModal(isNeedShowModal);
    if (!isNeedShowModal) handleNextModal();
  }, [atualPromotion, handleNextModal]);

  useEffect(() => {
    getInitialParams();
  }, [getInitialParams, window.location.pathname]);

  const saveClosed = useCallback(() => {
    localStorage.setItem(
      `@UltragazEmpresarial:${atualPromotion.localStorageKey}`,
      "yes"
    );
    handleNextModal();
    setShowModal(false);
  }, [atualPromotion, handleNextModal]);

  const handleClick = useCallback(
    (url: string | undefined) => {
      setTimeout(() => {
        window.open(url, "_blank");
      });
      saveClosed();
    },
    [saveClosed]
  );

  const CustomModal = useMemo(() => {
    if (atualPromotion?.CustomModalComponent) {
      return atualPromotion.CustomModalComponent;
    }
    return null;
  }, [atualPromotion]);

  return (
    showModal &&
    (CustomModal ? (
      // @ts-expect-error
      <CustomModal closeCallBack={saveClosed} />
    ) : (
      <Container>
        <Content>
          <CloseContainer>
            <ButtonClose
              onClick={() => {
                saveClosed();
              }}
            >
              X
            </ButtonClose>
          </CloseContainer>
          {atualPromotion?.title && (
            <TextWrapper>
              <TextTitle
                dangerouslySetInnerHTML={{ __html: atualPromotion.title }}
              />
              {atualPromotion?.subTitle && (
                <TextSubTitle>{atualPromotion.subTitle}</TextSubTitle>
              )}
              {atualPromotion?.dinamicLinkPromotion && (
                <ButtonNPSContainer>
                  <ButtonNPS onClick={() => handleClick(dynamicUrl)}>
                    Clique aqui
                  </ButtonNPS>
                </ButtonNPSContainer>
              )}
            </TextWrapper>
          )}
          {atualPromotion?.img && (
            <ImgBanner
              src={atualPromotion.img}
              customWidth={atualPromotion?.customWidth}
              customHeight={atualPromotion?.customHeight}
              alt="Imagem promocional"
              isLink={
                !!atualPromotion?.linkPromotion &&
                atualPromotion?.buttonLink === false
              }
              onClick={() => {
                if (
                  atualPromotion.linkPromotion &&
                  atualPromotion?.buttonLink === false
                ) {
                  handleClick(atualPromotion.linkPromotion);
                  if (idNotification) {
                    updateNotification(idNotification);
                  }
                }
              }}
            />
          )}
          {atualPromotion.linkPromotion && atualPromotion?.buttonLink && (
            <Button onClick={() => handleClick(atualPromotion.linkPromotion)}>
              Votar
            </Button>
          )}
        </Content>
      </Container>
    ))
  );
};

export default BannerPromotions;
